import { HttpParams } from '@angular/common/http';
import { Result } from '@rtls/core/models/result.model';

import { Pagination } from '@rtls/core/models/rpc/pagination.model';
import { RtlsModels } from '@rtls/core/models/rtls/rtls-models';
import { Observable } from 'rxjs';
import { SearchQuery } from '../rpc/search-query';

export abstract class RtlsGenericService<T> {
	abstract useModel(models: RtlsModels, baseUrl?: string, requestParameters?: HttpParams): RtlsGenericService<T>;

	abstract get(uuid: string): Observable<T>;

	abstract search(query: SearchQuery | null, pagination: Pagination): Observable<Result<T>>;

	abstract getByExternalId(extId: string, provider: string): Observable<T>;

	abstract getAll(pagination?: Pagination): Observable<Result<T>>;

	abstract getTotalItems(isNullable: boolean): Observable<number | undefined>;

	abstract save(body: T): Observable<T>;

	abstract saveByPut(body: T, uuid?: string): Observable<T>;

	abstract upsert(original: T, updated: T): Observable<T>;

	abstract delete(uuid: string): Observable<T>;

	abstract deleteAll(): Observable<boolean>;
}
